import './App.css';
import 'rsuite/dist/rsuite.min.css';
import './index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Main from './components/main'
import View from './components/view'
import AnalyticsView from './components/analytics/orcAnalytics'

function App() {
  return (
    <div className="App">
      <BrowserRouter >
          <Routes>
            <Route path="/dashboard/:panel/" element={
                <Main />
              }>  
            </Route>
            <Route path="/view/:key" element={
                <View />
              }>  
            </Route>
            <Route path="/analytics/:key" element={
                <AnalyticsView />
              }>
            </Route>
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
